import defaultStateFactory from './state'

export const RESULTS_PER_PAGE = 12
export const TYPE = 'ARTICLE'


export const SEARCHES = {
  LATEST: {
    perPage: 3
  },
  CITYGUIDE: {
    perPage: 6,
    filter: {
      type: 'CITY_GUIDE',
      venue_id: null
    }
  },
  FEATURED: {
    perPage: 4,
    filter: {
      isFeatured: true
    }
  },
  PREFERENCED: {
    perPage: 2,
    filter: {}
  },
  SUBSCRIBED: {
    perPage: 3,
    filter: {}
  },
  VENUE: {
    perPage: 3,
    filter: {
      venue_id: null
    }
  },
  ALL: {
    perPage: RESULTS_PER_PAGE
  }
}

export const defaultState = defaultStateFactory()
